"use client";

import {
  Container,
  Title,
  Text,
  Button,
  Stack,
  Box,
  Card,
  Group,
  SimpleGrid,
  List,
} from "@mantine/core";
import {
  IconPalette,
  IconPhoto,
} from "@tabler/icons-react";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

export default function ContrastLevelAndYourBestColorsContent() {
  const t = useTranslations("contrastLevel");

  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">
        {/* Hero Section */}
        <Box ta="center">
          <Title order={1} size="h1" mb="md">
            {t("title")}
          </Title>
          <Text size="lg" c="dimmed" maw={600} mx="auto" mb="xl">
            {t("subtitle")}
          </Text>
        </Box>

        {/* Contrast Explanation */}
        <Card withBorder p="xl" radius="md">
          <Title order={2} mb="md">
            {t("sectionTitle")}
          </Title>
          <Text mb="lg">
            {t("intro")}
          </Text>
          <SimpleGrid cols={{ base: 1, md: 2 }} spacing="xl">
            <Box>
              <Title order={3} size="h4" mb="md" c="dark">
                {t("highContrastTitle")}
              </Title>
              <List size="sm" spacing="xs">
                <List.Item>{t("highContrastDarkHair")}</List.Item>
                <List.Item>{t("highContrastLightHair")}</List.Item>
                <List.Item>{t("highContrastBold")}</List.Item>
                <List.Item>{t("highContrastBest")}</List.Item>
              </List>
            </Box>
            <Box>
              <Title order={3} size="h4" mb="md" c="gray">
                {t("lowContrastTitle")}
              </Title>
              <List size="sm" spacing="xs">
                <List.Item>{t("lowContrastSimilar")}</List.Item>
                <List.Item>{t("lowContrastSoft")}</List.Item>
                <List.Item>{t("lowContrastMuted")}</List.Item>
                <List.Item>{t("lowContrastBest")}</List.Item>
              </List>
            </Box>
          </SimpleGrid>
        </Card>

        {/* CTA */}
        <Box ta="center" py="xl">
          <Title order={2} mb="md">
            {t("ctaTitle")}
          </Title>
          <Text size="lg" c="dimmed" mb="xl">
            {t("ctaDescription")}
          </Text>
          <Group justify="center" gap="md">
            <Button
              size="xl"
              component={Link}
              href="/color-analysis-quiz"
              color="violet"
              rightSection={<IconPalette size={20} />}
            >
              {t("quizButton")}
            </Button>
            <Button
              size="xl"
              variant="outline"
              component={Link}
              href="/ai-color-analysis"
              color="violet"
              rightSection={<IconPhoto size={20} />}
            >
              {t("photoAnalysisButton")}
            </Button>
          </Group>
        </Box>
      </Stack>
    </Container>
  );
}
